module.exports = __webpack_public_path__ + "img/Watermark_Heart@2x.96278faf.png";